export enum CommunicationTypeEnum {
  Announcement = 0,
  ReleaseNote = 1,
  TipsAndTricks = 2,
}
